import axios from '@core_utils/api/_axios'

const evaluations = {
    namespaced: true,
    state: {
        audit_category: [],
    },
    mutations: {
        set_audit_category(state, comments) {
            state.audit_category = comments
        },
    },
    getters: {},
    actions: {
        async fetchAuditCategory({commit}) {
            try {
                const response = await axios.get(`/evaluation/audit_category`)
                const result = response.data?.items ?? []
                result.unshift({code: null, category: '평가 분류를 선택해주세요.', category_ea: 'Please select an evaluation category.', category_ca: '请选择评分类别。'})
                commit('set_audit_category', response.data?.items ?? [])
            } catch (error) {
                console.error('Error fetching available comments:', error)
                commit('set_audit_category', [])
            }
        },
        async createAuditCategory({commit}, id) {
            try {
                const response = await axios.post(`/evaluation/audit_category`, {
                    id
                })
                commit('set_audit_category', response.data?.items ?? [])
            } catch (error) {
                console.error('Error fetching available comments:', error)
                commit('set_audit_category', [])
            }
        },
        async updateAuditCategory({commit}, id) {
            try {
                const response = await axios.put(`/evaluation/audit_category`, {
                    id
                })
                commit('set_audit_category', response.data?.items ?? [])
            } catch (error) {
                console.error('Error fetching available comments:', error)
                commit('set_audit_category', [])
            }
        },
        async deleteAuditCategory({commit}, id) {
            try {
                const response = await axios.delete(`/evaluation/audit_category`, {
                    id
                })
                commit('set_audit_category', response.data?.items ?? [])
            } catch (error) {
                console.error('Error fetching available comments:', error)
                commit('set_audit_category', [])
            }
        },
        setAuditCategory({commit}, comments) {
            commit('set_audit_category', comments)
        }
    }
}
export default evaluations
